//请自行添加语言资源
const orderTrack = {
  shipperName: '货主',
  companyName: '所属机构',
  projectName: '项目名称',
  customerOrderNo: '客户订单号',
  soOrSto: '客户相关单号',
  planNo:'运输计划单号',
  currLocation: '当前位置',
  reqDespatchDate: '要求发货日期',
  reqArriverDate: '要求送达日期',
  carrierName: '承运商',
  statusName: '调度单状态',
  totalQty: '总数量',
  totalWeight: '总毛重(Kg)',
  totalVolume: '总体积(m³)',
  totalNetWeight: '总净重(Kg)',
  originAddrProvinceName: '发货省份',
  originAddrCityName:'发货城市',
  originAddrDistrictName: '发货区/县',
  destAddrProvinceName: '收货省份',
  destAddrCityName: '收货城市',
  destAddrDistrictName: '收货区/县',
  transType: '运输方式',
  msg:{}
};
export default orderTrack



// WEBPACK FOOTER //
// ./src/page/transit/orderTrack/lang/orderTrack.zh.js